const hl8Token = 'a-tk';
const hl8UserInfo = 'a-user';

function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

function removeLocalStorage(key) {
  window.localStorage.removeItem(key);
}

function getLocalStorage(key) {
  return window.localStorage.getItem(key);
}

export const setToken = value => setLocalStorage(hl8Token, value);
export const getToken = () => getLocalStorage(hl8Token);
export const removeToken = () => removeLocalStorage(hl8Token);

export const setUserInfo = value => setLocalStorage(hl8UserInfo, value);
export const getUserInfo = () => getLocalStorage(hl8UserInfo);
export const removeUserInfo = () => removeLocalStorage(hl8UserInfo);
